import { axiosXhr } from '../axiosXhr';
import { deactivateActivityTracker } from '../activityTracker';
import { deactivateRefreshAccessToken } from '../refreshAccessToken';

export const LOGOUT = 'logout';
export const INACTIVITY = 'inactivity';
export const UNAUTHORIZED = 'unauthorized';
export const REFRESH_TOKEN_FAIL = 'refreshTokenFail';

export function appLogout(
  logoutTypeString = LOGOUT,
  redirectToHome = false,
  redirectUrl = `${window.location.origin}/home`
) {
  return axiosXhr({
    url: '/authentication/logout',
    method: 'POST',
    data: {},
    timeout: 3000,
  })
    .then(() => {
      deactivateActivityTracker();
      deactivateRefreshAccessToken();
      if (redirectToHome) {
        window.history.pushState(
          { logoutType: logoutTypeString },
          'Fitch Connect',
          redirectUrl
        );
      } else {
        window.location = redirectUrl;
      }
    })
    .catch(() => {
      deactivateActivityTracker();
      deactivateRefreshAccessToken();
      window.location = redirectUrl;
    });
}
